









import { Component, Vue } from 'vue-property-decorator';
import LoginFormComponent from '@/components/login/login-form.component.vue';
import ForgotPasswordComponent from '@/components/login/forgot-password-form.component.vue';
import { mapState } from 'vuex';

@Component({
  components: {
    LoginFormComponent,
    ForgotPasswordComponent
  },
  computed: {
    ...mapState('authentication', ['isLoginComponent'])
  }
})
export default class LoginComponent extends Vue {
  public isLoginComponent: boolean;
}
